import React, { useEffect } from 'react'
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import apiService from '../../services/apiServices'

const Reports = () => {
    return (
        <div>
            <Grid container spacing={2} sx={{ m: 0 }}>
                <Grid item xs={10} sm={4} lg={3}>
                    <Link to="/home/reports/creditor-monthly">
                        <div className="card card-5">
                            <h3>Raport mujor</h3>
                            {/* <h1>0</h1> */}
                        </div>
                    </Link>
                </Grid>
                <Grid item xs={10} sm={4} lg={3}>
                    <Link to="/home/reports/employees-cards">
                        <div className="card card-1">
                            <h3>Kartela e punëtorit</h3>
                            {/* <h1>0</h1> */}
                        </div>
                    </Link>
                </Grid>
            </Grid>
        </div>
    )
}

export default Reports